class Hook {
  constructor(id, event, action) {
    this.id = id;
    this.event = event;
    this.enabled = false;
    this.action = action;
  }

  execute(params) {
    if (this.enabled === false) return;
    this.action(params);
  }
}

export default Hook;
